import { Component, inject } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { TranslatePipe } from '@ngx-translate/core';

export interface BusySnackbarData {
  message: string;
}

@Component({
  selector: 'lfw-busy-snackbar',
  templateUrl: './busy-snackbar.component.html',
  styleUrl: './busy-snackbar.component.scss',
  imports: [MatIconButton, MatIcon, TranslatePipe]
})
export class BusySnackbarComponent {
  private readonly data: BusySnackbarData = inject(MAT_SNACK_BAR_DATA);
  private readonly snackBarRef = inject(MatSnackBarRef<BusySnackbarComponent>);

  readonly message = this.data.message;

  dismiss(): void {
    this.snackBarRef.dismiss();
  }
}
